import { readableDate } from '@chocolate-soup-inc/cs-api-consumer-utils';
import _ from 'lodash';
import { getReadableDependant } from '../dependants/shared';
import type { TEmployeeType } from './queries';

const EMPLOYEE_EXPORT_COLUMNS = [
  { key: 'fullName', width: 30 },
  { key: 'company', width: 30 },
  { key: 'externalId', width: 24 },
  { key: 'office', width: 24 },
  { key: 'country', width: 16 },
  { key: 'hireDate', width: 14 },
  { key: 'birthDate', width: 14 },
  { key: 'dependants', width: 80 },
  //{ key: 'isPaused', width: 12 },
  { key: 'createdAt', width: 14 },
  { key: 'email', width: 32 },
  { key: 'address1', width: 32 },
  { key: 'address2', width: 24 },
  { key: 'city', width: 20 },
  { key: 'state', width: 16 },
  { key: 'zipCode', width: 14 },
  { key: 'fullAddress', width: 48 },
  { key: 'companyId', width: 40 },
  { key: 'officeId', width: 40 }
] as const;

export const employeeExportRows = (employees: TEmployeeType[]) => {
  return employees.map((employee) => ({
    fullName: employee.fullName,
    company: employee.company?.name,
    externalId: employee.externalId,
    office: employee.office?.name,
    country: employee.address?.country,
    hireDate: employee.hireDate ? readableDate(employee.hireDate, 'yyyy-MM-dd') : null,
    birthDate: employee.birthDate ? readableDate(employee.birthDate, 'yyyy-MM-dd') : null,
    dependants:
      _.compact(employee.dependants?.items)
        .filter((dependant) => !dependant._deleted)
        .map(getReadableDependant)
        .join('; ') || 'None',
    //isPaused: employee.isPaused ? 'TRUE' : 'FALSE',
    createdAt: employee.createdAt ? readableDate(employee.createdAt, 'yyyy-MM-dd HH:mm') : null,
    email: employee.email,
    address1: employee.address?.address1,
    address2: employee.address?.address2,
    city: employee.address?.city,
    state: employee.address?.state,
    zipCode: employee.address?.zipCode,
    fullAddress: employee.address
      ? `${employee?.address.address1}${employee?.address.address2 ? ', ' + employee?.address.address2 : ''}. ${employee?.address.city}, ${employee?.address.state}, ${employee?.address.country}. ${employee?.address.zipCode}`
      : undefined,
    //companyId: employee.companyId,
    officeId: employee.officeId
    //id: employee.id,
  }));
};

export const employeeXlsx = async (employees: TEmployeeType[]) => {
  const { Workbook } = await import('exceljs');
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Employees');

  worksheet.columns = EMPLOYEE_EXPORT_COLUMNS.map(({ key, width }) => ({ header: key, key, width }));
  worksheet.addRows(employeeExportRows(employees));

  const grayBorder = {
    bottom: { color: { argb: 'FFB7B7B7' }, style: 'thin' as const },
    left: { color: { argb: 'FFB7B7B7' }, style: 'thin' as const },
    right: { color: { argb: 'FFB7B7B7' }, style: 'thin' as const },
    top: { color: { argb: 'FFB7B7B7' }, style: 'thin' as const }
  };

  worksheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.border = grayBorder;
    });
  });

  worksheet.getRow(1).eachCell((cell) => {
    cell.fill = {
      fgColor: { argb: 'FFD9D9D9' },
      pattern: 'solid',
      type: 'pattern'
    };
    cell.font = { bold: true };
  });
  worksheet.views = [{ state: 'frozen', ySplit: 1 }];

  return workbook.xlsx.writeBuffer();
};
